import { render, staticRenderFns } from "./PersonalDialog.vue?vue&type=template&id=676bdf02&"
import script from "./PersonalDialog.vue?vue&type=script&lang=js&"
export * from "./PersonalDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports